var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 0h400v300h-400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 300h399.996v179.996h-399.996z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 300h399.996v179.996h-399.996z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.387-50-50-50h-300c-27.6133 0-50 22.3828-50 50v380c0 27.613 22.3867 50 50 50h239.996l110.004-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.813 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#5e68bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#4d5599"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.352 384.973 96.793-96.793v96.793z",
    fill: "#4d5599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.613 0-50 22.387-50 50v60h110z",
    fill: "#aeb3de"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.8906 417.699h38.8004v-12.258h-13.226v-45.441h-12.438v45.441h-13.1364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.625 417.699h13.219l11.586-17.644 11.992 17.644h12.863l-18.262-27.426 20.063-30.273h-12.848l-13.718 20.508-13.661-20.508h-13.125l20.278 30.234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.129 417.699h38.805v-12.258h-13.231v-45.441h-12.433v45.441h-13.141z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m365 210h-245c-8.285 0-15 6.719-15 15 0 8.285 6.715 15 15 15h245c8.285 0 15-6.715 15-15 0-8.281-6.715-15-15-15",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365 150h-245c-8.285 0-15 6.719-15 15s6.715 15 15 15h245c8.285 0 15-6.719 15-15s-6.715-15-15-15",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365 90h-245c-8.285 0-15 6.7188-15 15 0 8.281 6.715 15 15 15h245c8.285 0 15-6.719 15-15 0-8.2812-6.715-15-15-15",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 70h-15v200h15z",
    fill: "#ebcfcf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.26d18a43c81594c7b34922b6628336bd.svg";
export { ForwardRef as ReactComponent };